export enum HallFilterTypes {
    MARKET = "market",
    COUNTRY = "country",
    SEARCH = "search",
    PROVIDER = "provider",
    SERVER_TYPE = "server_type",
    HALL_STATUS = "hall_status",
    VIEW_MODE = "view_mode"
}

export enum HallListViews {
    LIST = "list",
    GRID = "grid"
}

/**
 * Interface for an applied Hall Filter.
 */
export interface HallFilter {
    type: HallFilterTypes;
    filterValues: any[];
}
